import { render, staticRenderFns } from "./ysqpxblist.vue?vue&type=template&id=a2a568e8&scoped=true"
import script from "./ysqpxblist.vue?vue&type=script&lang=js"
export * from "./ysqpxblist.vue?vue&type=script&lang=js"
import style0 from "./ysqpxblist.vue?vue&type=style&index=0&id=a2a568e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a568e8",
  null
  
)

export default component.exports